import { ErrorState } from "@dexibit/core";

import { Styled404Container } from "../styles";

const FourOhFourPage = () => {
  return (
    <Styled404Container>
      <ErrorState title="Oops, that page does not exist" fullScreen={false} transparent />
    </Styled404Container>
  );
};

export default FourOhFourPage;
